<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:150px;">About the Author</h1><br/>
<p style="font-family:Times New Roman;">David was born in Brighton, UK, but mainly educated in Australia. He is Emeritus Professor of Economic Geology at the University of Western Australia, a Fellow of the Australian Academy of Science and a National Geoscience Champion, having received numerous medals and other awards for his teaching and research. He is also a consultant to the mining and exploration industry, mainly involved in conceptual targeting for discovery of new mineral deposits. He has adapted his holistic and multi-scale approach to forensic geological studies into the writing of cerebral thriller, mystery and mystical novels, involving a gold exploration background, with <em>The Plagues’ Protocol</em> the first of this genre and <em>Destiny on Magic White Mountain</em> the second.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?73439bc0